// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"OrganizationsPage_toolbar__1Khbo","add":"OrganizationsPage_add__1fXz9","table":"OrganizationsPage_table__3In2L"};